import React from "react";

// LeftBtnArea component
// const LeftBtnArea = () => (
//     <div className="leftBtn_area">
//         {/* <div className="Rectangle-btn calendar !justify-start animate-pulse"></div>
//         <div className="Rectangle-btn calendar !justify-start animate-pulse"></div> */}
//         <div className=" !justify-start tasks animate-pulse"></div>
//         <div className=" !justify-start filehub animate-pulse"></div>
//         <div className=" !justify-start tasks animate-pulse"></div>
//         <div className=" !justify-start filehub animate-pulse"></div>
//         <div className=" !justify-start filehub animate-pulse">
//         </div>
//     </div>
// );
const NavSkeleton = () => (
    <div className="update_version_section space-y-2 animate-pulse pb-4 dark:!bg-surface-dark dark:text-white">
        {/* Dashboard Skeleton */}
        <div className="main_dashboard relative">
            <div className="flex flex-col items-center gap-y-2.5  ">
                <div className="w-4 h-4 bg-gray-300 rounded"></div>
                <div className="ml-3 h-4 bg-gray-300 rounded   w-10"></div>
            </div>
        </div>

        {/* Tasks Skeleton */}
        <div className="taskArea relative">
            <div className="flex flex-col items-center gap-y-2.5">
                <div className="w-4 h-4 bg-gray-300 rounded"></div>
                <div className="ml-3 h-4 bg-gray-300 rounded  w-10"></div>
            </div>
        </div>

        {/* File Hub Skeleton */}
        <div className="fileHub_area relative">
            <div className="flex flex-col items-center gap-y-2.5">
                <div className="w-4 h-4 bg-gray-300 rounded"></div>
                <div className="ml-3 h-4 bg-gray-300 rounded   w-10"></div>
            </div>
        </div>

        {/* Calendar Skeleton */}
        <div className="calendarArea relative">
            <div className="flex flex-col items-center gap-y-2.5 ">
                <div className="w-4 h-4 bg-gray-300 rounded"></div>
                <div className="ml-3 h-4 bg-gray-300 rounded   w-10"></div>
            </div>
        </div>

        {/* ERPNext Skeleton */}
        <div className="WorkflowArea relative">
            <div className="flex flex-col items-center gap-y-2.5 ">
                <div className="w-4 h-4 bg-gray-300 rounded"></div>
                <div className="ml-3 h-4 bg-gray-300 rounded  w-10"></div>
            </div>
        </div>

        {/* Sales Skeleton */}
        {/* <div className="salesArea relative">
            <div className="flex flex-col items-center gap-y-2.5 s">
                <div className="w-4 h-4 bg-gray-300 rounded"></div>
                <div className="ml-3 h-4 bg-gray-300 rounded w-16"></div>
            </div>
        </div> */}
    </div>
);

// RoomList component
const RoomList = () => {

    return (
        <div className="room_list_area">
            <div className="border-b border-b-[#475674]">
                <div className="pb-1">
                    {[1, 2].map((index) => (
                        <div key={index} className="flex justify-between w-full gap-4 pl-4 pb-2 pt-2 pr-4">
                            <div className="h-5 bg-gray-300 rounded w-full ww-[88%] animate-pulse "></div>
                        </div>
                    ))}
                </div>
            </div>
            <div className="group_container" style={{ height: 'calc(-530px + 100vh)', overflow: 'hidden' }}>
                <div className="list_container pinned_list !mt-1">
                    {[1, 2].map((index) => (
                        <div key={index} className="flex justify-between w-full gap-4 pl-4 pb-2 pt-2 pr-4">
                            <div className="h-5 bg-gray-300 rounded w-full ww-[88%] animate-pulse "></div>
                        </div>
                    ))}
                </div>
                <div className="list_container create_conv_list">
                    <ul className="mt-2">
                        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20].map((room, index) => (
                            <div key={index} className="flex justify-between w-full gap-4 pl-4 pb-2 pt-2 pr-4">
                                <div className="h-5 bg-gray-300 rounded w-full ww-[88%] animate-pulse "></div>
                            </div>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

// LeftContainer component (Main container)
const LeftContainerSkeleton = () => (
    <div className="left_container">
        <div className="left_top_bar">
            <div className="flex justify-between w-full pl-4 pb-4 pt-[23px] pr-4">
                <div className="h-9 bg-gray-300 rounded w-full animate-pulse "></div>
                {/* <div className="h-9 bg-[#182A4C] rounded w-32 animate-pulse"></div> */}
            </div>
            <div className="filtrSection animate-pulse"></div>
            <NavSkeleton />
        </div>
        <div className="flex justify-between w-full gap-4 pl-4 pb-2 ppt-4 pr-4">
            <div className="h-7 bg-gray-300 rounded-full w-full ww-[88%] animate-pulse "></div>
            {/* <div className="h-7 bg-[#041332] rounded w-[12%] animate-pulse"></div> */}
        </div>
        <div className="left_bottom_section">
            <RoomList />
        </div>
    </div>
);

export default LeftContainerSkeleton;
